/** Organizations, branches and members. */
import { api } from '../lib/apiClient.js';

// --- organizations ---------------------------------------------------------

/** The organizations the signed-in user belongs to. Drives the switcher. */
export const myOrganizations = () => api.get('/tenancy/tenants', { skipTenant: true });

/**
 * There is deliberately no `createOrganization`.
 *
 * Organizations are created by a platform administrator in ERP-ADMIN, together
 * with their owner. The endpoint that used to back a create form here no longer
 * exists, and the one that replaced it is platform-admin only.
 */

export const getOrganization = (tenantId) => api.get(`/tenancy/tenants/${tenantId}`);

export const updateOrganization = (tenantId, payload) => api.put(`/tenancy/tenants/${tenantId}`, payload);

// --- branches --------------------------------------------------------------

export const listBranches = (tenantId, query) => api.list(`/tenancy/tenants/${tenantId}/branches`, query);

/** Minimal active list, for a form's branch picker. */
export const branchOptions = (tenantId) => api.get(`/tenancy/tenants/${tenantId}/branches/select`);

export const getBranch = (tenantId, branchId) => api.get(`/tenancy/tenants/${tenantId}/branches/${branchId}`);

export const createBranch = (tenantId, payload) => api.post(`/tenancy/tenants/${tenantId}/branches`, payload);

export const updateBranch = (tenantId, branchId, payload) =>
  api.put(`/tenancy/tenants/${tenantId}/branches/${branchId}`, payload);

export const deleteBranch = (tenantId, branchId) =>
  api.delete(`/tenancy/tenants/${tenantId}/branches/${branchId}`);

// --- members ---------------------------------------------------------------

export const listMembers = (tenantId, query) => api.list(`/tenancy/tenants/${tenantId}/members`, query);

export const getMember = (tenantId, memberId) => api.get(`/tenancy/tenants/${tenantId}/members/${memberId}`);

/**
 * Adds a member by email. If the address has no account yet, one is created
 * and a temporary password is returned exactly once.
 */
export const addMember = (tenantId, payload) => api.post(`/tenancy/tenants/${tenantId}/members`, payload);

export const updateMember = (tenantId, memberId, payload) =>
  api.put(`/tenancy/tenants/${tenantId}/members/${memberId}`, payload);

export const removeMember = (tenantId, memberId) =>
  api.delete(`/tenancy/tenants/${tenantId}/members/${memberId}`);
